<template>
  <div>
        <section class="banner-sec bg bg-4">
      <div class="container">
        <div class="bg-content">
          <h1 class="size-40 regular">Andalepide on-demand</h1>
          <p class="size-20">Las mejores comidas para tu próxima reunión o evento empresarial.</p>
          <div class="banner-btn"><a type="button" data-toggle="modal" data-target="#subscribe" class="btn btn-hg btn-primary btn-fill">COMENZAR</a></div>
        </div>
      </div>
    </section>
    <section class="section white">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <img class="fe-4" src="/images/backgrounds/bg-sandwich2.png"/>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 pull-right">
            <div class="box-text">
              <h1 class="lato size-32 sm-centered">Convertí la oficina en un lugar de encuentros y buenos momentos</h1>
              <p class="size-16 margin-bottom-40 sm-centered">Si tenés una reunión, almuerzo en equipo o cumpleaños, andalepide te acerca un menú variado para tu evento.</p>
            </div>  
            <div class="box-text icon-aside">
              <p class="size-16"><i class="icon-step icon-lunch icon-x5 icon-color-grey"></i> <span class="semibold">Reuniones de almuerzo</span><br/>Disfrutá con tus compañeros de un buen almuerzo, como en casa.</p>
              <p class="size-16"><i class="icon-step icon-muffin icon-x5 icon-color-grey"></i> <span class="semibold">Cumpleaños y aniversarios</span><br/>Personalizá tu cumpleaños con nuestras comidas.<br/>Cada uno elige su menú y disfrutan juntos de un delicioso almuerzo. </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section grey3 nopad-top-sm">
      <div class="float-element fe-7"></div>
      <div class="visible-xs visible-sm img-section">
        <img src="/images/backgrounds/bg5.jpg"/>
      </div>
      <div class="container">     
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="box-text">
              <h1 class="lato size-34 sm-centered">¿Cómo funciona nuestro on-demand?</h1>
            </div>
            <div class="box-ondemand">
              <p class="element-1 size-16">Crea una orden grupal y agrega a todos los invitados de la reunión/evento. Cada uno podrá elegir el plato que más le guste, de esta manera cada uno almuerza lo que quiere. </p>
              <i class="element-4 icon-list icon-x8 icon-color-brown"></i>
              <i class="element-5 icon-truck icon-x8 icon-color-brown"></i>
              <span class="element-6"></span>
              <span class="element-7"></span>
              <p class="element-2 size-16">Nosotros nos encargamos del resto, todos los platos llegan juntos y personalizados. </p>
              <a  data-toggle="modal" data-target="#subscribe" class="element-3 btn btn-outline btn-outline-grey">MAS INFO</a> 
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="head-text">
          <h1 class="lato size-34">Hacé tu pedido hoy</h1>
          <p class="size-16 hidden-br  -10 durationx050">Andalepide trae las mejores comidas a su empresa. Suscribite a nuestro programa <br/>de comidas en Córdoba Capital. Próximamente más ciudades.</p>     
        </div>
        <div class="box-text centered">
          <div class="box-text-btn">
            <a type="button" data-toggle="modal" data-target="#subscribe" class="btn btn-primary btn-fill margin-bottom-10">COMENZÁ AHORA</a>
            <p><router-link to="/suscripcion" class="btn-link deco-dotted">¿Querés pedir diariamente?</router-link></p>
            <!-- <p><a href="suscripcion.html" class="btn-link deco-dotted">¿Querés pedir diariamente?</a></p> -->
          </div>
        </div>
      </div>
    </section>
        <!-- Modal Suscribe -->
    <modal-suscribe></modal-suscribe>
        <!-- Fin modal suscribe-->
    
    <!-- Modal Partner -->
    <modal-partner></modal-partner>
    <!-- Fin modal partner-->
  </div>
</template>
<script>
import $ from 'jquery'
import ModalPartner from './ModalPartner'
import ModalSuscribe from './ModalSuscribe'
export default {
  components: {
    'modal-partner': ModalPartner,
    'modal-suscribe': ModalSuscribe
  },
  mounted () {
    $('html, body').animate({ scrollTop: 0 }, 'slow')
  }
}
</script>



// WEBPACK FOOTER //
// OnDemand.vue?e151f828